module.exports = __webpack_public_path__ + "img/ABYSS.43abf202.svg";